<!-- Begin page -->
<div id="app" *ngIf="!env.isMobile">
    <!-- <app-loader id="global-loader" [isFpLoader]="true"></app-loader> -->

    <!-- wrapper -->
    <div class="wrapper">

        <!-- ======= TOPBAR ======= -->
        <app-topnav></app-topnav>
        <!-- End TOPBAR -->
        <!-- Middle Content Start -->
        <div class="main">
            <div class="container-fluid container-fluid-5">
                <div class="row row5">
                    <!-- sidebar Start -->
                    <div class="sidebar col-md-2 d-none d-md-block">
                        <app-sidebar></app-sidebar>
                    </div>
                    <!--/ sidebar End -->

                    <!-- Right Section -->
                    <div class="col-md-10 featured-box">
                        <router-outlet></router-outlet>
                    </div>
                    <!--/ Right Section End -->

                </div>
            </div>
        </div>
        <app-footer></app-footer>

    </div>
    <!-- /wrapper -->

</div>
<!--/ app -->

<div id="app" *ngIf="env.isMobile">
    <!-- <app-loader id="global-loader" [isFpLoader]="true"></app-loader> -->

    <!-- ======= TOPBAR ======= -->
    <app-topnav></app-topnav>
    <!-- End TOPBAR -->
    <!-- Middle Content Start -->
    <router-outlet></router-outlet>
    
    <app-footer></app-footer>
</div>